import React from 'react';
//material-ui
import Grid from '@material-ui/core/Grid';
//Assets
import mail from '../../../static/img/mail.png';


export const AvisoMobileRequerido = () => {
    return (
        <div className="onboarding">
            <Grid container
                direction="row"
                justify="center"
                alignItems="center"
            >
                <Grid item xs={12} sm={12}>
                    <img src={mail} className="img-center" />
                </Grid>
                <Grid item xs={12}>
                    <div className="content-description">
                        <h5 className="title" >Tenés que estar en un celular</h5>
                        <h6 className="description">Volvé a abrir el email desde tu celular y luego <br></br>
                            apretá el botón que dice <strong>"Ya estoy en mi celular"</strong></h6>
                    </div>
                </Grid>
            </Grid>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/components/OnBoarding/error/AvisoMobileRequerido.js